var _defs, _style, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCgateicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "My project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 64,
    height: 58,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA6CAMAAAA3Dq9LAAAAAXNSR0IB2cksfwAAAHJQTFRF/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oA/3oAa1IxTAAAACZ0Uk5TAE/A9P+/TYZLAUf9H7vB8f5wgA33MBAg/PJ2xQcDQKDzvYSDTL4Y6xtXAAABZ0lEQVR4nM3W21bCMBAF0FECEqNSLxTvgJf//0VNaWmbZM5JqA/OA8xaZDbJTLpA5BBn5zOjxmy+EBIXevUhljaKYf0lqzfuCgrXFDA3EFhxoIKA44CBPahKgXAIfsGtPqMISK24Q1POAVB9swACVSEQCNY6DiTG2Em/bxk7UACLATJZd08AejcepgKma8LpQLsyPYU1BwQB9SYfOPkIcAclwOMUwF8nAPhXlDX12rOQD6Am9mdJZN0RdKBPU1mbWmumAQKAjCMQgDaRHCED8E1MAJvjfslFsgFQhz0oBaImMoDcgwzARw/UU4GRQeufBislIVDg2SaB3B24l9c0sA6BJnvL/ml7D3bQZuiXDY5xCwBpN0CfxgEQryLAMdPqG0EH+kwHRB3jaMEfAYpQAAyGP/7cjJ+jqD74lxbshl76/wake8CCNXkasOP1KwjMObCHwIIDSwjIB6v/xPUiX9+gD7u9/v0/Z/4sZspT2q0AAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 0,
    y: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCgateicon);
export default __webpack_public_path__ + "static/media/Cgateicon.c4bdbb10b131255c85cd7a24fff5896e.svg";
export { ForwardRef as ReactComponent };